(function () {
    'use strict';

    angular
        .module('core.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, $urlRouterProvider, $locationProvider, PATHS) {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/not-found');

        $stateProvider
            .state('app', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/application-layout.html`,
                onEnter: ($rootScope, AuthenticationService, HelperService) => {
                    $rootScope.isOauth = false;

                    return AuthenticationService
                        .handleSystemLoad()
                        .then(() => {
                            // HubService.handleNotificationHub();
                        })
                        .catch(error => {
                            HelperService.handleStateChangeError(error);
                        });
                }
            })
            .state('app.not-authorized', {
                title: 'Não Autorizado',
                url: '/not-authorized',
                templateUrl: `${PATHS.PHYSICAL}/components/not-authorized/not-authorized.html`,
                controller: 'NotAuthorizedController',
                controllerAs: 'vm'
            })
            .state('app.opening-process', {
                title: 'Processo de Abertura',
                url: '/opening-process',
                templateUrl: `${PATHS.PHYSICAL}/components/opening-process/opening-process.html`,
                controller: 'OpeningProcessController',
                controllerAs: 'vm'
            })
            .state('app.not-found', {
                title: 'Não Encontrado',
                url: '/not-found',
                templateUrl: `${PATHS.PHYSICAL}/components/not-found/not-found.html`,
                controller: 'NotFoundController',
                controllerAs: 'vm'
            })
            .state('app.home', {
                title: 'Home',
                url: '/',
                templateUrl: `${PATHS.PHYSICAL}/components/home/home.html`,
                controller: 'HomeController',
                controllerAs: 'vm'
            })
            .state('app.my-profile', {
                title: 'Meu Perfil',
                url: '/my-profile',
                templateUrl: `${PATHS.PHYSICAL}/components/my-profile/my-profile.html`,
                controller: 'MyProfileController',
                controllerAs: 'vm'
            })
    }
}());